import { Fragment, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { gettotalOffers } from "../../store/totaloffer/totaloffAction";
import { Link } from "react-router-dom";
import { baseUrl } from "../../utils/APi";
import { Swiper, SwiperSlide } from "swiper/react";
import video from "../../assets/image/video-item-bg.jpg";

import bg from "../../assets/image/meetings-bg.jpg";
import playIcon from "../../assets/image/play-icon.png";

const NewFact = () => {
  // const dispatch = useDispatch();
  // const lan = useSelector((state) => state.LanSlicer.language);
  // const { offers } = useSelector((state) => state.Offers);

  // useEffect(() => {
  //   if (offers?.length === 0 ) {
  //    const promise= dispatch(gettotalOffers(lan));
  //     return () => {
  //       promise.abort();
  //     };
  //   }
  // }, [lan, dispatch,offers?.length]);

  return (
    <section className="our-facts" style={{ backgroundImage: `url(${bg})` }}>
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="row">
              <div className="col-lg-12">
                <h2>A Few Facts About Our University</h2>
              </div>
              <div className="col-lg-6">
                <div className="row">
                  <div className="col-12">
                    <div className="count-area-content percentage">
                      <div className="count-digit">94</div>
                      <div className="count-title">Succesed Students</div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="count-area-content">
                      <div className="count-digit">126</div>
                      <div className="count-title">Current Teachers</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="row">
                  <div className="col-12">
                    <div className="count-area-content new-students">
                      <div className="count-digit">2345</div>
                      <div className="count-title">New Students</div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="count-area-content">
                      <div className="count-digit">32</div>
                      <div className="count-title">Awards</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 align-self-center">
            <div className="video" style={{ backgroundImage: `url(${video})` }}>
              <Link href="#" target="_blank">
                <img src={playIcon} alt="" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewFact;
